import { makeStyles } from "@saleor/macaw-ui";

const useStyle = makeStyles(
  theme => ({
    titleHeader: {
      marginBottom: 30
    },
    titlePage: {
      marginBottom: 8
    },
    containerTable: {
      border: "1px solid #009fb8",
      borderRadius: 4
    },
    rootTable: {
      borderRadius: 4,
      overflowX: "auto",
      width: "100%",

      "& .MuiTableCell-head": {
        color: theme.palette.grey[900]
      },
      "& .MuiTableCell-body": {
        borderTop: "1px solid #E0E0E0"
      },
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    rowTable: {
      cursor: "pointer",
      background: `#ffffff !important`
    },
    arrowIcon: {
      color: theme.palette.info.main
    },
    paginateFooter: {
      background: "rgba(212, 244, 248, 0.8)",
      padding: "12px 20px",
      borderRadius: 4
    },
    iconModal: {
      position: "absolute",
      left: "45%",
      top: "20px"
    },
    inlineBlock: {
      display: "inline-block",
      color: theme.palette.grey[900]
    }
  }),
  { name: "SaveDraftPage" }
);

export default useStyle;
